import { QueryModelCore } from "@/core/model.core";
import Browser from "@/core/browser";

export default class User {
  /**
   * 获取个人中心数据
   */
  async userCenterInfo() {
    const url = Browser.ysfMiniprogram ? '/api-mem/personal/center/queryYSF' : '/api-mem/personal/center/query';
    const result = await new QueryModelCore(url).get();
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取分销员状态信息
   */
  async distributionStatusInfo() {
    const url = '/api-mem/distribution/center/isSalesman';
    const result = await new QueryModelCore(url).get();
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取收货地址列表
   */
  async addressList() {
    const result = await new QueryModelCore('/api-mem/memAddress/list').get();
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取收货地址详情
   * @param {number} id 出行人id
   */
  async addressDetail(id) {
    const result = await new QueryModelCore('/api-mem/memAddress/query').get({ id });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 新增/修改收货地址信息
   * @param {Object} params {
   *    @param {number} id 如果是修改收货地址需传入此参数
   * }
   */
  async updateAddress(params) {
    const url = params.id ? '/api-mem/memAddress/update' : '/api-mem/memAddress/add';
    const result = await new QueryModelCore(url).post(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 删除收货地址
   * @param {Array<number>} ids 需要删除的收货地址id列表
   */
  async deleteAddress(ids) {
    const result = await new QueryModelCore('/api-mem/memAddress/delete').post(ids);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取出行人列表
   */
  async travelerList() {
    const result = await new QueryModelCore('/api-mem/personal/memTraveler/list').get();
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取出行人详情
   * @param {number} id 出行人id
   */
  async travelerDetail(id) {
    const result = await new QueryModelCore('/api-mem/personal/memTraveler/query').get({ id });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 批量获取出行人信息
   * @param {Array<number>} ids 出行人id列表
   */
  async travelerInfoByIds(ids) {
    const result = await new QueryModelCore('/api-mem/personal/memTraveler/queryList').get({ ids: ids.join(',') });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 新增/修改出行人信息
   * @param {Object} params {
   *    @param {number} id 如果是修改出行人需传入此参数
   * }
   */
  async updateTraveler(params) {
    const url = params.id ? '/api-mem/personal/memTraveler/update' : '/api-mem/personal/memTraveler/add';
    const result = await new QueryModelCore(url).post(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 删除出行人
   * @param {Array<number>} ids 需要删除的出行人id列表
   */
  async deleteTraveler(ids) {
    const result = await new QueryModelCore('/api-mem/personal/memTraveler/delete').post(ids);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取个人信息详细数据
   */
  async userInfo() {
    const result = await new QueryModelCore('/api-mem/personal/center/query/info').get();
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 修改个人信息详细数据
   */
  async updateUserInfo(params) {
    const result = await new QueryModelCore('/api-mem/personal/center/update/info').post(params);
    const { dataMap } = result;
    return dataMap;
  }

   /**
   * 默认收货地址修改
   */
   async updateDefauleAddress(params) {
    const result = await new QueryModelCore('/api-mem/memAddress/update/default').post(params);
    const { dataMap } = result;
    return dataMap;
  }
}